import { MultiSelect } from "@mantine/core";
import { useState, useEffect } from "react";
import { IconTrash } from "@tabler/icons";

const AIRequestErrorSelect = ({ form, name, label }) => {
  const aiRequest = form.values;
  const foundErrors = aiRequest.foundErrors || [];
  const [data, setData] = useState([
    "Client duplicated",
    "Client name",
    "Wrong Charges Items",
    "Wrong Cost Items",
    "Wrong Commission Splitting",
    "Wrong Levy",
    "Missing Debit Note",
    "Missing Quotation",
    "Missing Renewal",
    "Missing Files",
  ]);

  const handleRemoveOption = (optionToRemove) => {
    setData((current) => current.filter((option) => option !== optionToRemove));
    // Also remove from form values if it's selected
    if (foundErrors?.includes(optionToRemove)) {
      form.setFieldValue(
        "foundErrors",
        foundErrors?.filter((error) => error !== optionToRemove)
      );
    }
  };

  return (
    <MultiSelect
      label={label}
      data={data}
      searchable
      creatable
      nothingFound="Not Found"
      value={foundErrors}
      onChange={(value) => {
        form.setFieldValue("foundErrors", value);
      }}
      onBlur={() => {
        form.setFieldValue("foundErrors", foundErrors);
      }}
      getCreateLabel={(query) => `+ Create ${query}`}
      onCreate={(query) => {
        setData((current) => [...current, query]);
        return query;
      }}
      itemComponent={({ value, ...others }) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "8px 12px",
          }}
        >
          <span {...others}>{value}</span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handleRemoveOption(value);
            }}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#666",
              padding: "4px",
              borderRadius: "3px",
              marginLeft: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            // onMouseEnter={(e) => {
            //   e.target.style.backgroundColor = "#f0f0f0";
            // }}
            // onMouseLeave={(e) => {
            //   e.target.style.backgroundColor = "transparent";
            // }}
            title={`Remove "${value}" from options`}
          >
            <IconTrash size={14} />
          </button>
        </div>
      )}
    />
  );
};

export default AIRequestErrorSelect;
